/*=========================================================================================
  File Name: state.js
  Description: Order Manager Actions
  ----------------------------------------------------------------------------------------
  Item Name: Order Manager State Module
  Author: Tan Tran
==========================================================================================*/
import queries from '../../../services/ordermanager/queries'
import commands from '../../../services/ordermanager/commands'
import TimeFormatter from '../../../common/utils/TimeFormatter'
import Moment from 'moment';
export default {

  async getCurrentOrdersAction( {commit, state, rootState }, payload ) {

    let restaurantId = rootState.auth.auth.restaurantId;

    await queries.getCurrentOrders(restaurantId)
                 .then( data => {
                   commit('SET_CURRENTORDERS_STATE', data)
                 });
  },

  async getCurrentWaitingTimeAction( {commit, state, rootState }, payload ) {

    let restaurantId = rootState.auth.auth.restaurantId;

    await queries.getCurrentWaitingTime(restaurantId)
                 .then( data => {
                   commit('SET_CURRENT_WAITING_TIME_STATE', data)
                 });
  },

  async getOrderManagerStateAction ({commit, state, rootState }, payload) {
    let restaurantId = rootState.auth.auth.restaurantId;

    await queries.getOrderManagerState(restaurantId)
                .then( data => {
                  console.log(data)
                  commit('SET_ORDER_MANAGER_STATE', data)
                });
  },

  async updateOrderToReadyOrderAction( { commit, state, rootState }, payload ) {
    
    let restaurantId = rootState.auth.auth.restaurantId;

    let index = rootState.restaurant.SMSSenders.findIndex(e => {
      return e.restaurantId == restaurantId
    });
    let sender = "27333";
    let duration = 5;
    if(index > -1) {
      sender = rootState.restaurant.SMSSenders[index].smsSender; 
      duration = rootState.restaurant.SMSSenders[index].duration;
    }
    
    let info = {
      restaurantId : restaurantId,
      orderId : payload.orderId,
      sendSMS : true,
      sender : sender,
      duration : duration,
      isDelivered : payload.isDelivered
    };
    console.log(info)
    
    return await commands.updateOrderToReadyOrder(restaurantId, info)
                          .then( response => {
                            console.log(response)
                            if(response.isSuccess) {
                              commit('SET_ORDER_TO_READY_STATE', response);
                              commit('SET_PENDING_TO_INPROGRESS_STATE', response);
                              return true;
                            }
                            return false;
                          });

  },

  async updateOrderPickupTimeAction( { commit, state, rootState }, payload ) {
    
    let restaurantId = rootState.auth.auth.restaurantId;

    let info = {
      restaurantId : restaurantId,
      orderId : payload.orderId,
      newPickupTime : TimeFormatter.timeToString(payload.newPickupTime)
    };
    //console.log(info)
    return await commands.updateOrderPickupTime(restaurantId, info)
                          .then( response => {
                            if(response) {
                              commit('SET_ORDER_PICKUP_TIME_STATE', payload);
                              
                              return response;
                            }
                            return response;
                          });
  },

  async updateOrderPickupDateAction( { commit, state, rootState }, payload ) {
    
    let restaurantId = rootState.auth.auth.restaurantId;

    let info = {
      restaurantId : restaurantId,
      orderId : payload.orderId,
      newPickupTime : payload.pickupTime.format('HH:mm:ss'),
      newPickupDate : payload.pickupDate.format("DD/MM/YYYY")
    };
    console.log(info)
    return await commands.updateOrderPickupDate(restaurantId, info)
                          .then( response => {
                            if(response) {
                              console.log('From updateOrderPickupDateAction ');
                              console.log(response);
                              commit('SET_ORDER_PICKUP_DATE_STATE', response);
                              commit('SET_PENDING_TO_INPROGRESS_STATE', response);
                              return response;
                            }
                            return response;
                          });
  },

  async updateOrderPriorityOrAsapAction( { commit, state, rootState }, payload ) {
    
    let restaurantId = rootState.auth.auth.restaurantId;

    let info = {
      restaurantId : restaurantId,
      orderId : payload.orderId,
      asap : payload.asap,
      priority : payload.priority
    };
    console.log('updateOrderPriorityOrAsapAction')
    return await commands.updateOrderPriorityOrAsap(restaurantId, info)
                          .then( response => {
                            if(response) {
                              console.log(response);
                              commit('SET_ORDER_PRIORITY_ASAP_STATE', response);
                              return response;
                            }
                            return response;
                          });
  },

  async updateCurrentWaitingTimeAction ( { commit, state, rootState }, payload ) {
    let restaurantId = rootState.auth.auth.restaurantId;
    console.log(payload)
    return await commands.updateCurrentWaitingTime(restaurantId, payload)
                          .then( response => {
                            if(response) {
                              commit('SET_CURRENT_WAITING_TIME_STATE', payload);
                              return response;
                            }
                            return response;
                          });
  },

  async updateCapacityAction ( { commit, state, rootState }, payload ) {
    let restaurantId = rootState.auth.auth.restaurantId;
    return await commands.updateCapacity(restaurantId, payload)
                          .then( response => {
                            if(response) {
                              commit('SET_CAPACITY_STATE', payload);
                              console.log(response)
                              return response;
                            }
                            return response;
                          });
  },

  async cancelOrderAction( { commit, state, rootState }, payload ) {
    console.log('cancel order action is called!')
    let restaurantId = rootState.auth.auth.restaurantId;
    console.log(payload)
    
    return await commands.cancelOrder( restaurantId, payload )
                        .then(res => {
                          console.log(res)
                          if (res != null) {
                            commit('CANCEL_ORDER_STATE', res);
                            commit('SET_PENDING_TO_INPROGRESS_STATE', res);
                          }
                          return res.isSuccess;
                        });
  },

  async printOrderFromClientAction( { commit, state, rootState }, payload ) {
    payload.restaurantId = rootState.auth.auth.restaurantId
    return await commands.printOrderFromClient(payload); 
  }
    
}